
import {ISelectItem} from "winfakt-vue-components";
import {Validatable} from "winfakt-vue-components/src/mixins/validatable";
import {Department, getDepartmentName} from "@/utils/department";

export default Validatable.extend({
	props: {
		value: [Number as () => Department, Array as () => Department[]],
		fancy: Boolean,
		label: String,
		multi: Boolean
	},
	computed: {
		items(): ISelectItem<number>[] {
			return [
				Department.None,
				Department.Sales,
				Department.TechnischeDienst,
				Department.DevWfShopOrOnline,
				Department.Programmatie,
				Department.Secretariaat,
				Department.Marketing,
				Department.Servicepakket,
				Department.Ticketsysteem,
				Department.Winfakt,
				Department.Overzetting,
				Department.Boekhoudportaal
			].map(d => {
				return {
					text: getDepartmentName(d),
					value: d
				};
			});
		}
	},
	methods: {
		onInput(val: Department | Department[]) {
			this.$emit("input", val);
		}
	}
});
